// extracted by mini-css-extract-plugin
export default {"btnCart":"ShoppingCart_btnCart__ek8Ki","shoppingCart":"ShoppingCart_shoppingCart__81tL4"};